

























import { Vue, Component, Emit } from "vue-property-decorator";
import { statusListPlural } from "@/models/solicitacoes";
import { statusOrcamentoList } from "@/models/orcamento-auto-online/StatusOrcamentosModel";

// @ts-ignore
import _ from 'lodash';

@Component({
   props: ["servico"]
})

export default class PromoCard extends Vue {
  detalhes(descricao: any, tipo: any) {

    if (tipo === 'REPAROVEICULAR') {      
      let tipoSolicitacao = _.find(statusOrcamentoList, function(o: any) { 
        return _.includes(_.lowerCase(o.descricao), _.lowerCase(descricao));
      });
      this.$router.push({
        name: "OrcamentosSolicitados",
        params: { status: tipoSolicitacao }
      });
    } else {      
      let tipoSolicitacao = _.find(statusListPlural, function(o: any) { 
        return _.includes(_.lowerCase(o.descricao), _.lowerCase(descricao));
      });
      this.$router.push({
        name: "AcompanhamentoNovasSolicitacoes",
        params: { status: tipoSolicitacao.valor, tipo: tipo }
      });
    }
  }

  piscar(quantidade: any, descricao: String) : boolean {
    if (quantidade > 0 && (descricao == 'Solicitado' || descricao == 'Aguardando')) {
      return true;
    }
    return false;
  }

}
